export const WEIGHT = 'weight'
export const TIER = 'tier'
